// extracted by mini-css-extract-plugin
module.exports = {"Container":"Auth_Container__1mT3e","Controls":"Auth_Controls__xaIWj","Link":"Auth_Link__20WSU","Error":"Auth_Error__BkJd8"};